import styled from '@emotion/styled';
import { space } from 'styled-system';

export const Wrapper = styled.div`
  display: inline-block;
  width: 100%;
  background: white;
  border: 1px solid var(--color-indigo-t3);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  padding: 2px;
  border-radius: 4px;
  margin-bottom: 10px;

  ${space}
`;

export const Content = styled.div`
  max-height: 250px;
  overflow-y: auto;
`;

export const Label = styled.label<any>`
  cursor: pointer;
  color: var(--color-indigo-t11);
  display: flex;
  width: 100%;
  padding: 16px 15px;
  border-radius: 4px;

  &:hover {
    background: var(--color-vibrant-blue-t0);
  }

  background: ${(p) => p.selected && `var(--color-vibrant-blue-t1);`};
  background: ${(p) => p.focused && `var(--color-vibrant-blue-t0);`};
`;

export const Input = styled.input`
  position: absolute;
  visibility: hidden;
  display: none;

  &:checked + ${Label} {
    background: red;
  }
`;
